module.exports = __webpack_public_path__ + "static/media/img-eabde58a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/bh-logo.png
// module id = 5278
// module chunks = 39